import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const CardsSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default CardsSVG;
